import { PollingStatus, StatusProvider } from '@/tax/models';
import { Company } from '@/organisations/models';


export class AnnualReport {
    id = 0;
    report = '';
    createdAt = new Date();
    status = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    company?: number;
    companyName?: string;
    progress = 0;


    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.report = data.report ?? '';
        this.createdAt = data.created_at ? new Date(data.created_at) : new Date();
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.company = data.company ?? undefined;
        this.companyName = data.company_name ?? undefined;
        this.progress = data.progress ?? 0;
        return this;

    }
}
